import services from '@/services'

import * as types from './mutations-types'

import router from '@/router'

import { inIframe } from '@/helpers'

export const setCustomFields = (context, customFields) =>
  context.commit(types.SET_CUSTOM_FIELDS, customFields)

export const overrideSetCustomFields = (context, customFields) =>
  context.commit(types.OVERRIDE_SET_CUSTOM_FIELDS, customFields)

export const setOrganization = (context, organization) =>
  context.commit(types.SET_ORGANIZATION, organization)

export const changeRoute = (_, route = '') => {
  const currentPath =
    router &&
    router.history &&
    router.history.current &&
    router.history.current.fullPath

  if (currentPath && currentPath !== route) {
    router.push(route)
  }
}

export const goToConversation = async context => {
  if (await context.dispatch('validLogin')) {
    if (!context.getters.flux) {
      await context.dispatch('chooseFlux')
    }

    const { flux } = context.getters

    if (flux && flux.botId) {
      context.dispatch('changeRoute', '/conversation')
    } else {
      const onlineCount = await context.dispatch('verifyOnlineAgents')

      if (onlineCount > 0) {
        context.dispatch('changeRoute', '/conversation')
      } else {
        context.dispatch('changeRoute', '/contact')
      }
    }
  } else if (router.currentRoute.name !== 'login') {
    context.dispatch('changeRoute', '/login')
  }
}

export const setCompany = (context, company) =>
  context.commit(types.SET_COMPANY, company)

export const setEmbedId = (context, id) =>
  context.commit(types.SET_EMBED_ID, id)

export const setQueryOptions = async (context, options) => {
  context.commit(types.SET_OPTIONS, options)

  await context.dispatch('setParentUrl', options.url)
}

export const setSettings = async context => {
  let settings = services.session.getChatSettings()

  if (settings === null) {
    settings = await services.settings.getSettings()

    services.session.setChatSettings(settings)
  }

  context.commit(types.SET_SETTINGS, settings)

  return settings
}

export const setReady = context => {
  context.commit(types.SET_READY, true)

  services.iframe.changeIFrameClasses()

  services.iframe.notifyIsReady()
}

export const fetchForm = async (context, formId) => {
  context.commit(types.SET_FETCHING_FORM, true)

  let form = {
    fields: []
  }

  if (formId) {
    const fluxForm = context.getters.fluxForm

    if (fluxForm && fluxForm.id === formId) {
      form = fluxForm
    } else {
      try {
        form = await services.form.getForm(formId)
      } catch (ex) {
        console.error(`error on get form ${formId}`, ex)
      }
    }
  }

  context.commit(types.SET_FORM, form)

  context.commit(types.SET_FETCHING_FORM, false)

  return form
}

export const getAgentsFilter = async (context, limit) => {
  const filterAgents = await services.agents.getAgentsFilter(limit)

  context.commit(types.SET_FILTER_AGENTS, filterAgents)

  return filterAgents
}

export const validConversationRoute = context => {
  if (
    context.getters.active &&
    !(
      context.getters.chat &&
      (context.getters.chat.status === 0 || context.getters.chat.status === 1)
    ) &&
    !context.getters.setContactMessageSent
  ) {
    context.dispatch('goToConversation')
  }
}

export const toggleApp = context => {
  context.commit(types.TOGGLE_APP)

  context.dispatch('startFluxBot')

  context.dispatch('setSessionActive')

  context.dispatch('readMessages')

  context.dispatch('validConversationRoute')

  services.iframe.changeIFrameClasses()

  if (context.getters.active) {
    context.dispatch('setShowStories', false)

    context.dispatch('setProactiveMsgVisible', false)
  }
}

export const activeApp = context => {
  context.commit(types.ACTIVE_APP)

  context.dispatch('startFluxBot')

  context.dispatch('setSessionActive')

  context.dispatch('readMessages')

  context.dispatch('validConversationRoute')

  services.iframe.changeIFrameClasses()

  context.dispatch('setShowStories', false)

  context.dispatch('setProactiveMsgVisible', false)
}

export const hideApp = (context, hide) => {
  context.commit(types.HIDE_APP, hide)
}

export const inactiveApp = context => {
  context.commit(types.INACTIVE_APP)

  context.dispatch('setSessionActive')

  services.iframe.changeIFrameClasses()
}

export const setLastDomainFrom = (context, url) =>
  services.room.setLastDomainFrom(context.getters.chatKey, url)

export const setParentUrl = async (context, url) => {
  if (url && url.length) {
    if (context.getters.parentUrl !== url) {
      context.dispatch('setLastDomainFrom', url)
    }

    await context.dispatch('setPage', url)

    context.commit(types.SET_PARENT_URL, url)
  }
}

export const setFocused = context => {
  context.commit(types.SET_FOCUS, true)

  context.dispatch('readMessages')
}

export const setBlurred = context => context.commit(types.SET_FOCUS, false)

export const log = (_, message) => services.widget.log(message)

export const getCulture = async ({ getters, commit }) => {
  if (getters.culture) {
    return getters.culture
  }

  const culture = services.session.getCulture()

  if (culture) {
    return culture
  }

  const serverCulture = await services.company.getCulture()

  commit(types.SET_SUBDOMAIN_CULTURE, serverCulture)
  services.session.setCulture(serverCulture)

  return serverCulture
}

export const verifyHasTicketApp = async () => {
  let hasTicketApp = services.session.getHasTicketApp()

  if (hasTicketApp !== undefined && hasTicketApp !== null) {
    return hasTicketApp
  }

  const companyModel = await services.company.getCompanyModel()

  const company = companyModel && companyModel.company

  if (!company && !company.apps) {
    services.session.setHasTicketApp(false)
    return false
  }
  const TICKET_APP_ID = 'cfa41304-b512-13f5-eed4-5ee2972802be'
  hasTicketApp = company.apps.some(app => app.productId === TICKET_APP_ID)
  services.session.setHasTicketApp(hasTicketApp)

  return hasTicketApp
}

export const redirectToLink = (_, { url, target }) => {
  if (url && typeof window !== 'undefined') {
    if (target === '_blank' || target === '_system') {
      if (inIframe) {
        services.iframe.postMessage({
          name: 'changeUrl',
          url,
          target
        })
      } else {
        window.open(url, target)
      }
    } else {
      if (inIframe) {
        services.iframe.postMessage({
          name: 'changeUrl',
          url
        })
      } else {
        window.location.href = url
      }
    }
  }
}
export const setWhitelabel = (context, whitelabel) => {
  context.commit(types.SET_WHITELABEL, whitelabel)
}
